var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9 1H8.2C7.00653 1 5.86193 1.47411 5.01802 2.31802C4.17411 3.16193 3.7 4.30653 3.7 5.5V8.2H1V11.8H3.7V19H7.3V11.8H10L10.9 8.2H7.3V5.5C7.3 5.26131 7.39482 5.03239 7.5636 4.8636C7.73239 4.69482 7.96131 4.6 8.2 4.6H10.9V1Z",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook01);
export default __webpack_public_path__ + "static/media/facebook01.95b319d27147fe983ed5c717703400fe.svg";
export { ForwardRef as ReactComponent };